export const PRODUCTS_TITLE = Object.freeze({
  SAFE: "Safe",
  SPAM: "Spam",
  ARC: "Arc",
  WEB: "Web",
});

export const PRODUCTS_LINK = Object.freeze({
  SAFE: "https://www.titanhq.com/safetitan-customer-signup?from_product=webtitan&to_product=safetitan",
  SPAM: "https://www.titanhq.com/spamtitan-customer-signup?from_product=webtitan&to_product=spamtitan",
  ARC: "https://www.titanhq.com/arctitan-customer-signup?from_product=webtitan&to_product=arctitan",
});

export const PRODUCTS_ICON = Object.freeze({
  SAFE: require("@/assets/branding/SafeTitan.png"),
  SPAM: require("@/assets/branding/SpamTitan.svg"),
  ARC: require("@/assets/branding/ArcTitan.svg"),
  WEB: require("@/assets/branding/Web Protection.svg"),
});

export const PRODUCTS_IMG = Object.freeze({
  SAFE: require("@/assets/branding/safetitan-square.png"),
  SPAM: require("@/assets/branding/spamtitan-square.png"),
  ARC: require("@/assets/branding/arctitan-square.png"),
});

export const PRODUCTS_DESCRIPTION = Object.freeze({
  SAFE: "Security Awareness Training",
  SPAM: "Email Anti-Spam Solution",
  ARC: "Email Archiving Solution",
  WEB: "DNS Filtering",
});

export const SPAM_CONTENT = Object.freeze({
  line1:
    "Advanced email phishing protection with AI driven, zero-day threat intelligence",
  line2:
    "Best-in-class protection against phishing, spear phishing and malware",
  line3:
    "Check every URL on every click - blocks user access to malicious or suspicious URLs",
});

export const ARC_CONTENT = Object.freeze({
  line1:
    "Cloud based email archiving - reduces the cost and complexity of archiving emails and satisfy discovery requests",
  line2: "Data loss prevention and regulatory and legal compliance",
  line3:
    "Significantly enhances Office 365 email search and storage functionality",
});

export const SAFE_CONTENT = Object.freeze({
  line1: "Security Awareness Training (SAT) powering human layer protection",
  line2:
    "Delivery contextual training in real-time. ONLY available from SafeTitan.",
  line3: "Unlimited phishing simulations",
});

export default {};
